import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "@heroicons/react/24/solid";
import { Button, Center, Icon, Text } from "@chakra-ui/react";

import { RoutesMap } from "../../../routes.tsx";

interface Props {
  title: string;
  link?: string;
}

export const PageHeader: FC<Props> = ({ title, link = RoutesMap.index }) => {
  const navigate = useNavigate();

  const onClick = () => {
    navigate(link);
  };

  return (
    <Center h="64px" w="100%" position="relative">
      <Button
        onClick={onClick}
        bg="transparent"
        position="absolute"
        left="0px"
        pl="5px"
        pb="1px"
        _hover={{ bg: "transparent" }}
      >
        <Icon as={ChevronLeftIcon} w="25px" h="25px" color="brand.500" />
      </Button>

      <Text fontSize="sm" variant="brand">{title}</Text>
    </Center>
  );
};
